import { AxiosPromise } from "axios";
import { format } from "date-fns";
import { httpClient } from "src/shared/services/httpClient";
import {
  TCashierForecastFilters,
  TCashierForecastResponse,
  TCashierPaymentDetailsResponse,
  TCashierRemittanceFileDetailsResponse,
  TCashierRemittancesResponse,
  TCompanyReducedSubscriptionFilters,
  TCompanyReducedSubscriptionResponse,
  TCompanyReducedSubscriptionSearchResponse,
  TCompanySubscriptionFilters,
  TCompanySubscriptionResponse,
  TDeleteKakFilters,
  TFinancialReportParamsResponse,
  TFindCompanyPaymentsFilters,
  TFindCompanyPaymentsResponse,
  TGetCashierReportParamsResponse,
  TInactiveUserAssignmentsResponse,
  TApplicationAssignedToInactiveUser,
  TCertificateApplicationAssignedToInactiveUser,
  TKedeSubscriptionsParamsResponse,
  TPaymentDetailsFilters,
  TSearchCompanySubscriptionResponse,
  TUnpaidSubscriptionsParamsResponse,
  TUpdateReducedCompanySubscriptionFilters,
  TUserDetailsFilters,
  TUserDetailsResponse,
  TGetBusinessUserResponse,
} from "../features/types";
import { TGetImpersonationBusinessPageResponse } from "src/admin/types";

export const getChamberDashParams = () => httpClient.get("chamber/dashboard");
export const getActiveOwnOnlyParams = () =>
  httpClient.get("chamber/activeOwnOnlyApplications");
export const getActiveOwnOnlyApps = (searchFilters: FormData) =>
  httpClient.post("chamber/getActiveOwnOnlyApplicationsJSON", searchFilters);

export const getActiveOwnApplicationsPaidParams = () =>
  httpClient.get("chamber/activeChamberApplicationsPaid");
export const getActiveApplicationsPaid = (searchFilters: FormData) =>
  httpClient.post(
    "chamber/getActiveChamberApplicationsJSON?paidFlag=true",
    searchFilters,
  );
export const getManageApplicationParams = (appId: string) =>
  httpClient.get(`chamber/manageApplicationReact?appId=${appId}`);

export const getCorrectionRevocation = () =>
  httpClient.get(`application/getCorrectionRevocation`);

export const getActionBarParams = (appId: string) =>
  httpClient.get(`chamber/applicationToolbar?applicationToolbarM02Id=${appId}`);
export const getAssignToUserParams = (appId: string) =>
  httpClient.get(`chamber/forwardToChamberUserForm?appId=${appId}`);
export const forwardApplication = ({
  appId,
  mode,
  a06_id,
  message,
  d05_id,
}: {
  appId: string;
  mode: string;
  a06_id?: string;
  message?: string;
  d05_id?: string;
}) => {
  const formData = new FormData();
  formData.append("appId", appId);
  formData.append("mode", mode);
  if (a06_id && a06_id.length > 0) {
    formData.append("a06_id", a06_id);
  }
  if (d05_id && d05_id.length > 0) {
    formData.append("d05_id", d05_id);
  }
  if (message && message.length > 0) {
    formData.append("message", message);
  }
  return httpClient.post("/chamber/forwardApplicationReact", formData);
};
export const getAppsByGemi = (formData: FormData) =>
  httpClient.post("/chamber/getAllApplicationsGemiJSON", formData);

export const getActiveChamberApplicationsUnpaidParams = () =>
  httpClient.get("chamber/activeChamberApplicationsUnpaid");
export const getActiveApplicationsUnpaid = (searchFilters: FormData) =>
  httpClient.post(
    "chamber/getActiveChamberApplicationsJSON?paidFlag=false",
    searchFilters,
  );
export const getActiveOwnApplicationsParams = () =>
  httpClient.get("chamber/activeOwnApplications");
export const getActiveOwnApplications = (formData: FormData) =>
  httpClient.post("chamber/getActiveOwnApplicationsJSON", formData);
export const getPastOwnApplicationsParams = () =>
  httpClient.get("chamber/pastOwnApplications");

export const getPastOwnApplications = (formData: FormData) => {
  return httpClient.post("chamber/getPastOwnApplicationsJSON", formData);
};

export const getActiveOwnCertificateApplicationsParams = () =>
  httpClient.get("chamber/activeOwnCertificateApplications");
export const getActiveOwnCertificateApplications = (formData: FormData) =>
  httpClient.post("chamber/getActiveOwnCertificateApplicationsJSON", formData);

export const getActiveChamberCertificatesPaidParams = () =>
  httpClient.get("chamber/activeChamberCertificateApplicationsPaid");
export const getActiveChamberCertificatesPaid = (formData: FormData) =>
  httpClient.post(
    "chamber/getActiveChamberCertificateApplicationsJSON?paidFlag=true",
    formData,
  );

export const getActiveChamberCertificatesUnpaidParams = () =>
  httpClient.get("chamber/activeChamberCertificateApplicationsUnpaid");
export const getActiveChamberCertificatesUnpaid = (formData: FormData) =>
  httpClient.post(
    "chamber/getActiveChamberCertificateApplicationsJSON?paidFlag=false",
    formData,
  );

export const getPastOwnCertificateApplicationsParams = () =>
  httpClient.post("chamber/pastOwnCertificateApplications");

export const getPastOwnCertificateApplications = (formData: FormData) =>
  httpClient.post("chamber/pastOwnCertificateApplicationsJson", formData);

export const getCertsByGemiId = (formData: FormData) =>
  httpClient.post("chamber/getAllCertificatesGemiJSON", formData);
// export const getPastOwnCertificateApplications = (formdata: FormData) =>
//   httpClient.post("chamber/getPastOwnApplicationsJSON", formdata);
export const updateUserComments = ({
  appId,
  m02_notes,
}: {
  appId: string;
  m02_notes: string;
}) => {
  const formData = new FormData();
  formData.append("m02_notes", m02_notes);
  formData.append("appId", appId);
  return httpClient.post("chamber/updateNotes", formData);
};
export const getChamberViewParams = (m02_id: string) =>
  httpClient.get(`application/chamberView?chamberViewM02_id=${m02_id}`);
export const getChamberFormParams = (m02_id: string) =>
  httpClient.get(`application/chamberForm?chamberViewM02_id=${m02_id}`);

export const getKAK = ({
  appId,
  selectedApplicationTypeId,
}: {
  appId: string;
  selectedApplicationTypeId?: string;
}) => {
  const formData = new FormData();
  if (selectedApplicationTypeId) {
    formData.append("selectedApplicationTypeId", selectedApplicationTypeId);
  }
  formData.append("appId", appId);

  return httpClient.post("application/migrateToGEMI", formData);
};

export const saveChamberMetadata = (formData: FormData) =>
  httpClient.post("chamber/chamberSubmitAnnouncementMetadata", formData);
export const saveChamberAnnFile = (formData: FormData) =>
  httpClient.post("chamber/chamberSubmitSignedAnnFile", formData);
export const saveUnsignedChamberAnnFile = (formData: FormData) =>
  httpClient.post("chamber/chamberSubmitUnsignedAnnFile", formData);
export const getManageCertificateApplicationParams = (certId: string) =>
  httpClient.get(`chamber/manageCertificateApplication?certId=${certId}`);
export const updateChamberCertificateNotes = ({
  n02_chambernotes,
  certId,
}: {
  n02_chambernotes: string;
  certId: string;
}) => {
  const formData = new FormData();
  formData.append("n02_chambernotes", n02_chambernotes);
  formData.append("certId", certId);
  return httpClient.post(`chamber/updateCertificateNotes`, formData);
};
export const uploadManualCertificate = ({
  n02_id,
  n03_id,
  fudocPdf,
}: {
  n02_id: string;
  n03_id: string;
  fudocPdf: any;
}) => {
  const formData = new FormData();
  formData.append("certAppId", n02_id);
  formData.append("itemId", n03_id);
  formData.append("fudocPdf", fudocPdf);
  return httpClient.post(`chamber/uploadPdf`, formData);
};

export const acceptAndForwardCertificate = ({
  n02_id,
  n03_id,
}: {
  n02_id: string;
  n03_id: string;
}) => {
  const formData = new FormData();
  formData.append("certId", n02_id);
  formData.append("itemId", n03_id);
  return httpClient.post(`chamber/forwardCompletedItemToUser`, formData);
};
export const sendBackToSign = ({
  n02_id,
  n03_id,
}: {
  n02_id: string;
  n03_id: string;
}) => {
  const formData = new FormData();
  formData.append("certId", n02_id);
  formData.append("itemId", n03_id);
  return httpClient.post(`chamber/editItem`, formData);
};
export const uploadSignedManualCertificate = ({
  n02_id,
  n03_id,
  fudocSignedPdf,
}: {
  n02_id: string;
  n03_id: string;
  fudocSignedPdf: any;
}) => {
  const formData = new FormData();
  formData.append("certAppId", n02_id);
  formData.append("itemId", n03_id);
  formData.append("fudocSignedPdf", fudocSignedPdf);
  return httpClient.post(`chamber/forwardSignedItemToChamberUser`, formData);
};

export const forwardToChamberSigner = ({
  n02_id,
  n03_id,
  signerId,
  signedPath,
}: {
  n02_id: string;
  n03_id: string;
  signerId: string;
  signedPath?: string;
}) => {
  const formData = new FormData();
  formData.append("certId", n02_id);
  formData.append("itemId", n03_id);
  formData.append("signerId", signerId);
  if (signedPath) {
    formData.append("signedPath", signedPath);
  }
  return httpClient.post(`chamber/forwardItemToChamberSignerReact`, formData);
};
export const getAuthorityCertificateInsertFormParams = (
  certId: string,
  bid: string,
  d08_id: string,
) =>
  httpClient.get(
    `chamber/authorityCertificateInsertForm?authorityCertificateInsertFormD08_id=${d08_id}&authorityCertificateInsertFormBid=${bid}&authorityCertificateInsertFormCertId=${certId}`,
  );

export const updateCertificateHistory = ({
  h00_protokolo,
  h00_date,
  d05_id,
  h00_fek,
  h00_text,
  fucertFile,
  certId,
  bid,
}: {
  h00_protokolo: string;
  h00_date: string;
  d05_id: string;
  h00_fek: string;
  h00_text: string;
  fucertFile: any;
  certId: string;
  bid: string;
}) => {
  const formData = new FormData();
  formData.append("h00_protokolo", h00_protokolo);
  formData.append("h00_date", h00_date);
  formData.append("d05_id", d05_id);
  formData.append("h00_fek", h00_fek);
  formData.append("h00_text", h00_text);
  formData.append("fucertFile", fucertFile[0]);
  formData.append("certId", certId);
  formData.append("bid", bid);
  return httpClient.post("chamber/updateHistory", formData);
};
export const getChamberFormCertificateParams = (certId: string) =>
  httpClient.get(`chamber/chamberForm?chamberFormCertId=${certId}`);

export const updateCertificatePostDate = ({
  n02_ts_posted,
  certId,
}: {
  n02_ts_posted: string;
  certId: string;
}) => {
  const formData = new FormData();
  formData.append("n02_ts_posted", n02_ts_posted);
  formData.append("certId", certId);
  return httpClient.post(`chamber/updateCertificatePostDate`, formData);
};

export const forwardCertificateApplication = ({
  a06_id,
  message,
  certId,
  mode,
}: {
  a06_id: string;
  message: string;
  certId: string;
  mode: string;
}) => {
  const formData = new FormData();

  formData.append("a06_id", a06_id);
  formData.append("message", message);
  formData.append("certId", certId);
  formData.append("mode", mode);
  return httpClient.post("chamber/forwardCertificateApplication", formData);
};
export const getForwardToCertificateChamberUserFormParams = (certId: string) =>
  httpClient.get(
    `chamber/forwardCertificateToChamberUserForm?certId=${certId}`,
  );
export const getNewApplicationCompanies = (filters: {
  argemi: string;
  afm: string;
  coName: string;
}) => {
  const formData = new FormData();
  formData.append("argemi", filters.argemi ?? "");
  formData.append("afm", filters.afm ?? "");
  formData.append("coName", filters.coName ?? "");
  return httpClient.post(`/chamber/newApplicationForReact?`, formData);
};

export const closeCertificateApplication = (certId: string) =>
  httpClient.post(`chamber/forwardCertificateToSuccess?certId=${certId}`);

export const getUserDetails = (
  filters: TUserDetailsFilters,
): AxiosPromise<TUserDetailsResponse> => {
  const formData = new FormData();
  formData.append("m01_e03_id", filters.m01_e03_id);
  return httpClient.post(`chamber/userDetails`, formData);
};

export const getCompanySubscriptionParams =
  (): AxiosPromise<TCompanySubscriptionResponse> =>
    httpClient.get("chamber/companySubscription");

export const getSearchCompanySubscription = (
  filters: TCompanySubscriptionFilters,
): AxiosPromise<TSearchCompanySubscriptionResponse> => {
  const formData = new FormData();
  formData.append("bid", filters.bid);
  formData.append("year", filters.year);
  return httpClient.post("chamber/searchSubscription", formData);
};

export const rollBackKak = (filters: TDeleteKakFilters) => {
  const formData = new FormData();
  formData.append("appId", filters.appId);
  return httpClient.post(
    `${filters.isSystemAdmin ? "admin" : "chamber"}/rollbackKak`,
    formData,
  );
};

export const getCashierForecastPayments = (
  filters: TCashierForecastFilters,
): AxiosPromise<TCashierForecastResponse> => {
  const formData = new FormData();
  formData.append(
    "fromDate",
    format(filters.fromDate, "dd/MM/yyyy").toString(),
  );
  formData.append("toDate", format(filters.toDate, "dd/MM/yyyy").toString());
  return httpClient.post(`/chamber/cashierForecast`, formData);
};

export const getCashierPaymentDetails = (
  params: TPaymentDetailsFilters,
): AxiosPromise<TCashierPaymentDetailsResponse> => {
  const formData = new FormData();
  formData.append("type", params.type);
  formData.append("date", params.date);
  return httpClient.post(`/chamber/cashierPaymentDetails`, formData);
};

export const getCashierRemittances = (
  filters: TCashierForecastFilters,
): AxiosPromise<TCashierRemittancesResponse> => {
  const formData = new FormData();
  formData.append(
    "fromDate",
    format(filters.fromDate, "dd/MM/yyyy").toString(),
  );
  formData.append("toDate", format(filters.toDate, "dd/MM/yyyy").toString());
  return httpClient.post(`/chamber/cashierRemittances`, formData);
};

export const getCashierRemittancesFileDetails = (
  p04Id: number,
): AxiosPromise<TCashierRemittanceFileDetailsResponse> =>
  httpClient.get(`/chamber/remittancesFileDetails?p04Id=${p04Id}`);

export const downloadRemittancesFileCsv = (p04Id: number) =>
  httpClient.get(`/chamber/exportRemittancesFileCsv?p04Id=${p04Id}`, {
    responseType: "blob",
  });

export const getFindCompanyPayments = (
  filters: TFindCompanyPaymentsFilters,
): AxiosPromise<TFindCompanyPaymentsResponse> => {
  const formData = new FormData();
  formData.append("bid", filters.bid ?? "");
  formData.append("afm", filters.afm ?? "");
  return httpClient.post(`/chamber/findCompanyPayments`, formData);
};

export const getCompanyReducedSubscription = (
  isSystemAdmin: boolean,
): AxiosPromise<TCompanyReducedSubscriptionResponse> =>
  httpClient.get(
    `/${isSystemAdmin ? "admin" : "chamber"}/companyReducedSubscription`,
  );

export const getSearchCompanyReducedSubscription = (
  filters: TCompanyReducedSubscriptionFilters,
  isSystemAdmin: boolean,
): AxiosPromise<TCompanyReducedSubscriptionSearchResponse> => {
  const formData = new FormData();
  formData.append("year", filters.year);
  formData.append("bid", filters.bid);
  formData.append("months", filters.months);
  return httpClient.post(
    `/${isSystemAdmin ? "admin" : "chamber"}/searchReducedSubscription`,
    formData,
  );
};

export const updateReducedCompanySubscription = (
  filters: TUpdateReducedCompanySubscriptionFilters,
) => {
  const formData = new FormData();
  formData.append("year", filters.year);
  formData.append("bid", filters.bid);
  formData.append("amount", filters.amount.toString());
  formData.append("m05Id", filters.m05Id);
  formData.append("m06Id", filters.m06Id);
  formData.append("months", filters.months.toString());
  formData.append("mode", filters.mode.toString());

  return httpClient.post(
    `/${filters.isSystemAdmin ? "admin" : "chamber"}/updateReducedSubscription`,
    formData,
  );
};

export const getFinancialReportParams =
  (): AxiosPromise<TFinancialReportParamsResponse> =>
    httpClient.get("chamber/financialReport");

export const getCashierReportParams =
  (): AxiosPromise<TGetCashierReportParamsResponse> =>
    httpClient.get("chamber/cashierReport");

export const getUnpaidSubscriptionsParams =
  (): AxiosPromise<TUnpaidSubscriptionsParamsResponse> =>
    httpClient.get("chamber/unpaidSubscriptions");

export const getKedeSubscriptionsParams =
  (): AxiosPromise<TKedeSubscriptionsParamsResponse> =>
    httpClient.get("chamber/kedeSubscriptions");

export const getCashierStats = async () => {
  return httpClient.get("chamber/cashierStatsJSON");
};

export const getManageSubscriptionParams = (
  isSystemAdmin: boolean,
  formData: FormData,
) => {
  return httpClient.post(
    `/${isSystemAdmin ? "admin" : "chamber"}/manageSubscription`,
    formData,
  );
};

export const getForwardToRegionFormParams = (appId: string) => {
  const formData = new FormData();
  formData.append("appId", appId);
  return httpClient.post("chamber/forwardToRegionForm", formData);
};

export const impersonateBusiness = (filters: {
  id: string;
  m01Id: string;
}): AxiosPromise<TGetBusinessUserResponse> => {
  const formData = new FormData();
  formData.append("bid", filters.id);
  formData.append("m01Id", filters.m01Id);
  return httpClient.post("/chamber/impersonationBusiness", formData);
};

export const getImpersonationPageBusinessParams = (
  argemi: string,
): AxiosPromise<TGetImpersonationBusinessPageResponse> =>
  httpClient.get("/chamber/impersonationPageBusiness?bid=" + argemi);

export const getUnsignedOwnCertificateApplications = (formData: FormData) =>
  httpClient.post(
    "chamber/getUnsignedOwnCertificateApplicationsJSON",
    formData,
  );

export const forwardMassiveCertificateApplications = ({
  a06_id,
  message,
  certIds,
}: {
  a06_id: string;
  message: string;
  certIds: string[];
}) => {
  const formData = new FormData();

  formData.append("a06_id", a06_id);
  formData.append("message", message);

  certIds.forEach((id) => {
    formData.append("certIds", id);
  });

  return httpClient.post(
    "chamber/forwardMassiveCertificateApplications",
    formData,
  );
};

export const forwardMassiveApplications = ({
  appIds,
  a06_id,
  message,
}: {
  appIds: string[];
  a06_id: string;
  message: string;
}) => {
  const formData = new FormData();

  appIds.forEach((id) => {
    formData.append("appIds", id);
  });

  if (a06_id && a06_id.length > 0) {
    formData.append("a06_id", a06_id);
  }

  if (message && message.length > 0) {
    formData.append("message", message);
  }

  return httpClient.post("/chamber/forwardMassiveApplications", formData);
};

export const updateChamberCertificateNotesForApplicant = ({
                                                              n02_chambernotes_for_user,
                                                              certId,
                                                          }: {
    n02_chambernotes_for_user: string;
    certId: string;
}) => {
    const formData = new FormData();
    formData.append("n02_chambernotes_for_user", n02_chambernotes_for_user);
    formData.append("certId", certId);
    return httpClient.post(`chamber/updateCertificateNotesForUser`, formData);
};

export const getApplicationsAssignedToInactiveUsers = (
  formData: FormData,
): AxiosPromise<TInactiveUserAssignmentsResponse<TApplicationAssignedToInactiveUser>> =>
  httpClient.post("chamber/getApplicationsAssignedToInactiveUsersJSON", formData);

export const getCertificateApplicationsAssignedToInactiveUsers = (
  formData: FormData,
): AxiosPromise<TInactiveUserAssignmentsResponse<TCertificateApplicationAssignedToInactiveUser>> =>
  httpClient.post("chamber/getCertificateApplicationsAssignedToInactiveUsersJSON", formData);
